import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import Meta from 'vue-meta'
import VeeValidate, { Validator } from 'vee-validate'
import Vuesax from 'vuesax'
import pl from 'vee-validate/dist/locale/pl'

import App from './App.vue'
import router from './router'
import store from './store/index'
import './registerServiceWorker'
import 'vuesax/dist/vuesax.css'
import { formatDate, formatDateShort } from '@/utils/dates'
import { formatMoney, formatQuantity } from '@/utils'

Vue.config.productionTip = false

Vue.use(Meta)
Vue.use(VeeValidate)
Vue.use(VueReCaptcha, { siteKey: '6Ldf0bEUAAAAAJcHYbXRQjSGprQgxg69NbzIh0yb' })
Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: '#8BD5CB',
    },
  },
})

Vue.filter('formatDate', (date) => formatDate(new Date(date)))
Vue.filter('formatDateShort', (date) => formatDateShort(new Date(date)))
Vue.filter('formatMoney', formatMoney)
Vue.filter('formatQuantity', formatQuantity)

Validator.localize('pl', pl)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
